<template>
	<div>
		<loader v-if="isLoading" object="#65C523" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
		<h2>Заполните контактную информацию</h2>
		<p>Заполните заявку полностью, это увеличит вероятность одобрения</p>
		<formInput :refs="'PASSPORT_SERIES'" ></formInput>
		<formInput :refs="'PASSPORT_NUMBER'" ></formInput>
		<formInput :refs="'PASSPORT_DEP_CODE'" ></formInput>
		<formInput :refs="'PASSPORT_DATE'" ></formInput>
		<formInput :refs="'BIRTHDAY'" ></formInput>
		<formInput :refs="'BIRTHPLACE'" ></formInput>
		<formSelectDadataPassport :refs="'PASSPORT_DEP'" ></formSelectDadataPassport>
		<formSelectDadata :refs="'REGISTRATION_ADDRESS'" ></formSelectDadata>
		<formCheckBox :name="'IS_ADDRESS_COINCIDES'" :true-value="'Y'" :false-value="'N'" ></formCheckBox>
		<formSelectDadata :refs="'RESIDENTIAL_ADDRESS'" ></formSelectDadata>
	</div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex';
	export default {
		name: "passport",
		data(){
			return {
				isLoading: false,
			}
		},
		components:{
			loader: () => import('@/components/abt/loader_box'),
			formInput: () => import('@/components/abt/form/abtInput'),
			formSelectDadata: () => import('@/components/abt/form/abtSelectDadata'),
			formSelectDadataPassport: () => import('@/components/abt/form/abtSelectDadataPassport'),
			formCheckBox: () => import('@/components/abt/form/abtCheckBox'),
		},
		mounted() {
			this.$store.dispatch('hideLoading');
			window.dblClick = false;
			if (window.ym) {
				// eslint-disable-next-line no-undef
				ym(51632228, 'reachGoal', 'variantB_fio');
			}
		},
		methods: {},
		computed:{
			...mapState({
				valueVuex: state => state.Form.sendData,
				statusVuex: state => state.Form.workData
			}),
			...mapGetters([
				'getRedirectUrl','doesNotRedirect','doesNotRejectRequest','isAdressValid'
			]),
		},
	}
</script>
<style scoped>
</style>
